const TOP = "_top";
const BLANK = "_blank";
const convertRelObjectToString = (rel) => `${(rel == null ? void 0 : rel.nofollow) ? "nofollow " : ""}${(rel == null ? void 0 : rel.sponsored) ? "sponsored " : ""}${(rel == null ? void 0 : rel.ugc) ? "ugc " : ""}${(rel == null ? void 0 : rel.noreferrer) ? "noreferrer" : ""}`.trim();
const convertRelStringToObject = (rel) => ({
  nofollow: rel == null ? void 0 : rel.includes("nofollow"),
  sponsored: rel == null ? void 0 : rel.includes("sponsored"),
  ugc: rel == null ? void 0 : rel.includes("ugc"),
  noreferrer: rel == null ? void 0 : rel.includes("noreferrer")
});
const convertTargetStringToBoolean = (target) => target === BLANK;
const convertTargetBooleanToString = (targetBlank) => targetBlank ? BLANK : TOP;
const getRelValue = (rel) => `noopener noreferrer ${rel || ""}`.trim();

export { convertRelObjectToString, convertRelStringToObject, convertTargetBooleanToString, convertTargetStringToBoolean, getRelValue };
//# sourceMappingURL=linkConverters.js.map
